var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CONFIG } from "../../config/app.config";
import api from "../../utils/api/api.utils";
import { BASE_PATH_ENTITY } from "./auth.constants";
export var signIn = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/sign-in"), {
                    data: data,
                    isV2: true,
                    authenticated: false,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var signInAutomatically = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/sign-in/token"), {
                    data: { token: token },
                    isV2: true,
                    authenticated: false,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var requestToken = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/sign-in/request-token"), {
                    data: { userId: userId },
                    isV2: true,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var refreshAccessToken = function (refreshToken) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/token-refresh"), {
                    data: { refreshToken: refreshToken },
                    isV2: true,
                    authenticated: false,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var requestPasswordReset = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/password/request-reset"), {
                    data: data,
                    isV2: true,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var resetPassword = function (token, newPassword) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/password/reset?access_token=").concat(token), {
                    data: { newPassword: newPassword },
                    isV2: true,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var signOutUser = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, api.post("/".concat(BASE_PATH_ENTITY, "/sign-out"), {
                isV2: true,
            })];
    });
}); };
export var adminResetSmsCount = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/admin-reset-sms-count"), {
                    data: { userId: userId },
                    isV2: true,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var verifyPhone = function (userId, code) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/confirm-phone"), {
        data: { userId: userId, code: code },
        isV2: true,
    });
};
export var adminVerifyEmail = function (userId) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/admin-confirm-email"), {
        data: { userId: userId },
        isV2: true,
    });
};
export var adminVerifyPhone = function (userId) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/admin-confirm-phone"), {
        data: { userId: userId },
        isV2: true,
    });
};
export var signUp = function (data) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/sign-up"), {
        data: data,
        isV2: true,
        authenticated: false,
    });
};
export var resendVerificationEmail = function (email) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/email/verification"), {
        data: { email: email },
        isV2: true,
    });
};
export var resendVerificationSms = function (phone) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/sms/verification"), {
        data: { phone: phone },
        isV2: true,
    });
};
export var getUser = function () {
    return api.get("/users/me", {
        isV2: true,
    });
};
export var getAccessTokenFromEmail = function (userId, token) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/request-access-token-from-email"), {
        data: { userId: userId, token: token },
        isV2: true,
    });
};
export var getTac = function (locale, platform, brokerId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, api.get("/".concat(BASE_PATH_ENTITY, "/brokers/").concat(brokerId || CONFIG.RENTIO_BROKER_ID, "/tac/").concat(platform, "/").concat(locale), {
                isV2: true,
            })];
    });
}); };
export var getTacById = function (tacId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, api.get("/".concat(BASE_PATH_ENTITY, "/tac/").concat(tacId), {
                isV2: true,
            })];
    });
}); };
export var updateUser = function (data) {
    return api.put("/".concat(BASE_PATH_ENTITY, "/users/me"), {
        data: data,
        isV2: true,
    });
};
export var updateUserById = function (id, data) {
    return api.patch("/users/".concat(id), {
        data: data,
        isV2: true,
    });
};
export var acceptTac = function (tacId) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/users/me/tac/").concat(tacId, "/accept"), {
        isV2: true,
    });
};
export var removeProfile = function () {
    return api.delete("/".concat(BASE_PATH_ENTITY, "/users/me/application/profile"), {
        isV2: true,
    });
};
